import { Injectable } from '@angular/core';
import { UnitOfWork } from './data/unit-of-work';
import { EntityQuery, Predicate } from 'breeze-client';
import CustomStore from 'devextreme/data/custom_store';
import { Repository } from './data/repository';
import moment from 'moment';
import { ArkUnitOfWork } from './core.module';

export { CustomStore };

@Injectable()
export class BreezeDxStoreService {
    operatorMap = {
        '=': 'eq',
        '<>': 'ne'
    };

    ready = true;
    uow: ArkUnitOfWork;

    constructor() {}

    createStore(uow: ArkUnitOfWork, repository: Repository<any>, query: EntityQuery, key: string, orderBy?: string, datatypes?: any) {
        this.uow = uow;
        const store: any = new CustomStore({
            key,
            byKey: keyValue => {
                return repository.byId(keyValue);
            },
            // insert: (values: any) => {
            //     return new Promise(null);
            // },
            // byKey: keyValue => {
            //     return repository.byId(keyValue);
            // },
            load: (loadOptions: any) => {
                if (!store.ready) return Promise.resolve({ data: [], totalCount: 0 });

                let storeQuery = query.skip(loadOptions.skip || 0);

                if (loadOptions.take) storeQuery = storeQuery.take(loadOptions.take);

                if (loadOptions.filter && loadOptions.filter.length > 0) {
                    const filter = this.compileCriteria(loadOptions.filter, datatypes);
                    storeQuery = storeQuery.where(filter);
                }

                if (loadOptions.sort && loadOptions.sort.length > 0) {
                    loadOptions.sort.forEach(item => {
                        storeQuery = storeQuery.orderBy(this.fixFieldName(item.selector), item.desc);
                    });
                } else {
                    storeQuery = storeQuery.orderBy(orderBy);
                }

                if (loadOptions.requireTotalCount) {
                    storeQuery = storeQuery.inlineCount();
                }

                // var userQuery = this._resolveUserQuery(loadOptions);
                // let storeQuery = this.createBreezeQuery(null, query, )

                return uow.manager.executeQuery(storeQuery).then(data => {
                    this.convertDataTypes(data.results, datatypes);
                    return {
                        data: data.results,
                        totalCount: data.inlineCount
                    };
                });
            },
            update: async (keyValue: any, values: any) => {
                console.log('update', keyValue, values);
                await this.uow.commit();
            }
        });
        (<any>store).ready = true;
        return store;
    }

    normalizeBinaryCriterion(crit) {
        return [crit[0], crit.length < 3 ? '=' : String(crit[1]).toLowerCase(), crit.length < 2 ? true : crit[crit.length - 1]];
    }

    convertDataTypes(data: any[], datatypes?: any) {
        if (!datatypes) return;

        const keys = Object.keys(datatypes);
        const dateKeys = keys.filter(key => {
            return datatypes[key] === 'date';
        });
        data.forEach(item => {
            dateKeys.forEach(dateKey => {
                if (item[dateKey]) item[dateKey] = moment.utc(item[dateKey]).toDate();
            });
        });
    }

    compileCriteria(criteria, datatypes?: any): Predicate {
        const _this = this;
        // var Predicate = Predicate;

        function translateBinaryOperator(op) {
            return _this.operatorMap[op] || op;
        }

        // tslint:disable-next-line:no-shadowed-variable
        function compileBinary(criteria) {
            criteria = _this.normalizeBinaryCriterion(criteria);

            let operator = criteria[1].toLowerCase();
            let shouldNegate = false;

            if (operator === 'notcontains') {
                operator = 'contains';
                shouldNegate = true;
            }

            let value = criteria[2];
            const datatype: string = datatypes && datatypes[criteria[0]];
            if (datatype) {
                if (datatype.indexOf('array') === 0) {
                    const field = datatype.substring(6);
                    return new Predicate(_this.fixFieldName(criteria[0]), 'any', field, translateBinaryOperator(operator), value);
                } else {
                    switch (datatypes[criteria[0]]) {
                        // case 'date':
                        // value = parseDate(value);
                        //    break;
                        case 'int':
                            value = parseInt(value, 10);
                            break;
                        case 'float':
                            value = parseFloat(value);
                            break;
                        // case 'array':
                        //     // value = parseFloat(value);
                        //     return new Predicate(_this.fixFieldName(criteria[0]), 'any', 'Name', translateBinaryOperator(operator), value);
                        // // break;
                    }
                }
            }
            const result = new Predicate(_this.fixFieldName(criteria[0]), translateBinaryOperator(operator), value);

            return shouldNegate ? Predicate.not(result) : result;
        }

        // tslint:disable-next-line:no-shadowed-variable
        function compileGroup(criteria) {
            const groupOperands = [];
            let groupOperator;
            let nextGroupOperator;

            criteria.forEach(item => {
                if (Array.isArray(item)) {
                    if (groupOperands.length > 1 && nextGroupOperator !== groupOperator)
                        throw Error('Mixing of and/or is not allowed inside a single group');

                    groupOperator = nextGroupOperator;
                    groupOperands.push(compileCore(item));
                    nextGroupOperator = 'and';
                } else {
                    nextGroupOperator = /and|&/i.test(item) ? 'and' : 'or';
                }
            });

            return groupOperands.length < 2 ? groupOperands[0] : Predicate[groupOperator].apply(null, groupOperands);
        }

        // tslint:disable-next-line:no-shadowed-variable
        function compileCore(criteria) {
            return Array.isArray(criteria[0]) ? compileGroup(criteria) : compileBinary(criteria);
        }

        return compileCore(criteria);
    }

    fixFieldName(name: string) {
        if (!name) return name;
        try {
            let parts = name.split('_');
            parts = parts.map(part => part.substring(0, 1).toLowerCase() + part.substring(1));
            return parts.join('.');
        } catch {
            return name;
        }
        // return name.replace(/_/g, '.').toLocaleLowerCase();
    }

    // _resolveUserQuery(loadOptions) {
    //     var result = (loadOptions && loadOptions.entityQuery) || this._userQuery;
    //     return result && result.from(this._resourceName);
    // }

    // createBreezeQuery(entityManager, resourceNameOrQuery, queryOptions, tasks) {
    //     tasks = tasks || [];
    //     queryOptions = queryOptions || {};

    //     function formatSortParam(field, desc) {
    //         return desc ? field + " desc" : field;
    //     }

    //     function createDerivedQuery(action, params) {
    //         return this.createBreezeQuery(entityManager, resourceNameOrQuery, queryOptions, tasks.concat([
    //             { action: action, params: params }
    //         ]));
    //     }

    //     function prepareEntityQuery(tasks) {
    //         var entityQuery = resourceNameOrQuery instanceof EntityQuery
    //             ? resourceNameOrQuery
    //             : new EntityQuery(resourceNameOrQuery);

    //         tasks.forEach(task => {
    //             entityQuery = entityQuery[task.action].apply(entityQuery, task.params);
    //         });

    //         return entityQuery;
    //     }

    //     function handleError(error) {
    //         var errorHandler = queryOptions.errorHandler;
    //         if (errorHandler)
    //             errorHandler(error);
    //         throw error;
    //     };

    //     // API

    //     function sortBy(field, desc) {
    //         return createDerivedQuery("orderBy", [formatSortParam(field, desc)]);
    //     }

    //     function thenBy(field, desc) {
    //         var lastTask = tasks[tasks.length - 1];
    //         if (!lastTask || lastTask.action !== "orderBy")
    //             throw Error("Cannot be called before sortBy");

    //         var clonedTasks = tasks.slice(0);
    //         clonedTasks[clonedTasks.length - 1].params[0] += "," + formatSortParam(field, desc);

    //         return this.createBreezeQuery(entityManager, resourceNameOrQuery, queryOptions, clonedTasks);
    //     }

    //     function filter(criteria) {
    //         if (!Array.isArray(criteria))
    //             criteria = Array.from(arguments);
    //         return createDerivedQuery("where", [this.compileCriteria(criteria)]);
    //     }

    //     function select(expr) {
    //         if (!Array.isArray(expr))
    //             expr = Array.from(arguments);

    //         var selectHash: any = {},
    //             expandHash: any = {},
    //             selectParam,
    //             expandItems,
    //             expandParam,
    //             newTasks = [];

    //         expr.forEach(item => {
    //             var term = String(item),
    //                 path = term.split(".");

    //             selectHash[term] = true;

    //             if (path.length > 1) {
    //                 path.pop();
    //                 expandHash[path.join(".")] = true;
    //             }
    //         });

    //         selectParam = selectHash.map((v, k) => { return k }).join();

    //         expandItems = expandHash.map((v, k) => { return k });

    //         if ((resourceNameOrQuery instanceof EntityQuery) && (resourceNameOrQuery as any).expandClause)
    //             expandItems = expandItems.concat((resourceNameOrQuery as any).expandClause.propertyPaths);
    //         expandParam = expandItems.join();

    //         newTasks.push({ action: "select", params: [selectParam] });

    //         if (expandParam) {
    //             newTasks.push({ action: "expand", params: [expandParam] });
    //         }

    //         return this.createBreezeQuery(entityManager, resourceNameOrQuery, queryOptions, tasks.concat(newTasks));
    //     }

    //     function enumerate() {
    //         // var d = $.Deferred().fail(handleError);
    //         var entityQuery = prepareEntityQuery(tasks);

    //         if (queryOptions.requireTotalCount)
    //             entityQuery = entityQuery.inlineCount(true);

    //         return entityManager
    //             .executeQuery(entityQuery)
    //             .then(function (obj) {
    //                 var extra;

    //                 if (isNumber(obj.inlineCount))
    //                     extra = { totalCount: obj.inlineCount };

    //                 return (obj.results, extra);
    //             })
    //             .fail(handleError);
    //     }

    //     function count() {
    //         // var d = $.Deferred().fail(handleError);
    //         let filteredTasks;
    //         let entityQuery;

    //         filteredTasks = tasks.filter(task => {
    //             return !/select|orderBy|take|skip/i.test(task.action);
    //         });

    //         entityQuery = prepareEntityQuery(filteredTasks);
    //         entityQuery = entityQuery
    //             .inlineCount(true)
    //             .take(0);

    //         return entityManager
    //             .executeQuery(entityQuery)
    //             .then(function (obj) {
    //                 return obj.inlineCount;
    //             })
    //             .fail(handleError);
    //     }

    //     function slice(skip, take) {
    //         var newTasks = [];
    //         if (skip)
    //             newTasks.push({ action: "skip", params: [skip] });
    //         if (take)
    //             newTasks.push({ action: "take", params: [take] });
    //         return this.createBreezeQuery(entityManager, resourceNameOrQuery, queryOptions, tasks.concat(newTasks));
    //     }
    // }
}
